(function($)
{
	'use strict';

	var containerMinHeight = function()
	{
		$('#container').css({
			'min-height': $(window).height() - $('#header').height() - $('#footer').height() + 'px'
		});
	};

	$(document).ready(containerMinHeight);
	$(window).on('load', containerMinHeight);

	// https://gitlab.com/inspiredminds/mcwerk-shop/issues/41 » https://stackoverflow.com/a/23012580/374996
	$('body').on('touchstart', function() {});

    /**
     * Save scroll pos
     */
    var getUrl = function() { return [location.protocol, '//', location.host, location.pathname].join(''); }
    var scrollpos = JSON.parse(localStorage.getItem('scrollpos'));
    if (scrollpos && scrollpos.url == getUrl() && $('.error').length === 0) {
        $(window).scrollTop(scrollpos.pos);
    }
    $(window).on('unload', function() {
        localStorage.setItem('scrollpos', JSON.stringify({
            pos: $(window).scrollTop(),
            url: getUrl()
        }));
    });

})(jQuery);
